import { createAsyncThunk } from "@reduxjs/toolkit";

import { ThunkConfig } from "@/app/providers/StoreProvider";
import { UserData } from "@/entities/User";
import { handleError } from "@/shared/lib/helpers/utils";
import { ApiError } from "@/shared/types";

interface Params {
  abortController: AbortController;
}

export const fetchProfile = createAsyncThunk<UserData, Params | void, ThunkConfig<ApiError>>(
  "auth/fetchProfile",
  async (params, thunkApi) => {
    const { extra, rejectWithValue } = thunkApi;

    try {
      const response = await extra.api.get<UserData>("/api/users-me", {
        signal: (params as Params | undefined)?.abortController?.signal,
      });

      return response.data;
    } catch (err) {
      return rejectWithValue(handleError(err));
    }
  }
);
